import React from 'react'
import PropTypes from 'prop-types'
import useCase from '../hooks/use-case'

function WhenCaseNotIn (props) {
  const caseValue = useCase()

  if (props.values.indexOf(caseValue) === -1) {
    return props.children
  }

  return null
}

WhenCaseNotIn.defaultProps = {
  values: null
}

WhenCaseNotIn.propTypes = {
  values: PropTypes.array.isRequired
}

export default WhenCaseNotIn
